var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNbfcicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 16,
    fill: "#64BD71",
    fillOpacity: 0.24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0767 35.2606C37.0767 30.9017 28.3589 28.7222 24 28.7222C19.6411 28.7222 10.9232 30.9017 10.9232 35.2606V36.4401C10.9232 36.9923 11.3709 37.4401 11.9232 37.4401H36.0767C36.629 37.4401 37.0767 36.9923 37.0767 36.4401V35.2606ZM24 23.6368C25.7341 23.6368 27.3971 22.948 28.6233 21.7218C29.8495 20.4956 30.5384 18.8325 30.5384 17.0984C30.5384 15.3644 29.8495 13.7013 28.6233 12.4751C27.3971 11.2489 25.7341 10.5601 24 10.5601C22.2659 10.5601 20.6028 11.2489 19.3766 12.4751C18.1505 13.7013 17.4616 15.3644 17.4616 17.0984C17.4616 18.8325 18.1505 20.4956 19.3766 21.7218C20.6028 22.948 22.2659 23.6368 24 23.6368Z",
    fill: "#64BD71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNbfcicon);
export default __webpack_public_path__ + "static/media/nbfcicon.861976ae128cffe4a153c2a14cd08625.svg";
export { ForwardRef as ReactComponent };